import {
  SupportedAccountingSoftware,
  SupportedAccountingSoftwareType,
} from '../types/SupportedAccountingSoftware';

const getAccountingSoftwareNameByType = (type: SupportedAccountingSoftwareType) => {
  switch (type) {
    case SupportedAccountingSoftware.NetSuite:
      return 'Oracle NetSuite';
    case SupportedAccountingSoftware.QuickBooksDesktop:
      return 'QuickBooks Desktop';
    case SupportedAccountingSoftware.QuickBooksOnline:
      return 'QuickBooks Online';
    case SupportedAccountingSoftware.Xero:
      return 'Xero';
    default:
      return '';
  }
};

export { getAccountingSoftwareNameByType };
